import { EarthquakeFeature } from '../features/alert-earthquake/earthquake.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class AlertsEarthquakesLayerRenderer extends StandardLayerRenderer {
  protected Feature = EarthquakeFeature;
}
